export default __webpack_public_path__ + "static/media/fixColumnRight.23aab527.svg";